/* @ngInject */
const accountFields = (
  accountLabels,
  icons,
  types
) => {
  let self = {}

  self = {
    'id': {
      ref: 'id',
      label: accountLabels.fields.id.text,
      icon: icons.account.id,

      output: false,
    },
    'username': {
      ref: 'username',
      label: accountLabels.fields.username.text,
      icon: icons.account.username,
      required: true,
      unique: true,
      nature: 'account',
      type: types.text(),
      output: {
        sortable: true,
        table: {
          display: true,
          prefill: true,
        },
      },
    },
    'password': {
      ref: 'password',
      label: accountLabels.fields.password.text,
      icon: icons.account.password,
      required: true,
      type: types.password,
      messages: accountLabels.fields.password.messages,
      output: false,
    },
    'passwordConfirmation': {
      ref: 'passwordConfirmation',
      label: accountLabels.fields.passwordConfirmation.text,
      icon: icons.account.passwordConfirmation,
      required: true,
      type: types.password,
      messages: accountLabels.fields.passwordConfirmation.messages,
      output: false,
    },
    'creationDate': {
      ref: 'creationDate',
      label: accountLabels.fields.creationDate.text,
      icon: icons.account.creationDate,
      output: {
        sortable: true,
        table: {
          display: true,
          prefill: true,
        },
      },
    },
    'admin': {
      ref: 'admin',
      label: accountLabels.fields.admin.text,
      icon: icons.account.admin,
      output: {
        table: {
          display: true,
          prefill: true,
        },
      },
    },
  }

  return self
}
export default accountFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/resources/fields.resource.js